// src/App.tsx
import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { default as ErrorBoundaryComponent } from "./components/error-boundary";
import LoadingIndicator from "./components/shared/loading-indicator";
import { getTokenDetails } from './functions/userSession';
import NotFound from './pages/NotFound';
import routes from './routes';
import { useAppDispatch } from './store/hooks';
import { updateToken } from './store/slices/user';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import RateLayout from "components/admin/modals/interestRateModals/ModalLayout";

const ErrorBoundaryLayout = () => (
  <ErrorBoundary FallbackComponent={ErrorBoundaryComponent}>
    <Outlet />
  </ErrorBoundary>
);

const SuspenseLayout = () => (
  <React.Suspense
    fallback={
      <div className="h-screen w-screen flex items-center justify-center">
        <LoadingIndicator size={100} />
      </div>
    }
  >
    <Outlet />
  </React.Suspense>
);

const App: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = getTokenDetails();
    if (token) {
      dispatch(updateToken({ token }));
    }
  }, [dispatch]);

  const router = createBrowserRouter([
    {
      element: <ErrorBoundaryLayout />,
      errorElement: <NotFound />,
      children: [
        {
          element: <SuspenseLayout />,
          children: routes,
        },
      ],
    },
    ]);

  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastContainer
        style={{
          fontSize: 16,
          zIndex: 30,
        }}
        theme="colored"
        autoClose={5000}
        position="top-right"
        hideProgressBar={true}
        closeOnClick={true}
      />
      {/* <RateLayout/> */}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

export default App;
